import { render, staticRenderFns } from "./questionTwoSteps.vue?vue&type=template&id=cf0f8938&scoped=true&"
import script from "./questionTwoSteps.vue?vue&type=script&lang=js&"
export * from "./questionTwoSteps.vue?vue&type=script&lang=js&"
import style0 from "./questionTwoSteps.vue?vue&type=style&index=0&id=cf0f8938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0f8938",
  null
  
)

export default component.exports